import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
  Button,
  DialogActions,
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import { AuthContext } from "../context";
import { orderServices } from "../services";
import {
  Toast,
  SimpleToolbar,
  Loader,
  Drawer,
  ModalBase,
  ConfirmationModal,
  TextField,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { filterNumber } from "../helpers";
import { useDrawer } from "../hooks";
import { EnableDisableIconButton } from "../components/icon-buttons";
import handleDownloadExcel from "../helpers/download-excel";
export default function AssignmentsScreen(props) {
  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [reload, setReload] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [productId, setProductId] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [doctorId, setDoctorId] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const { register, errors } = useForm();
  const { isOpen, setIsOpen } = useDrawer();
  const [modal, setModal] = useState(false);
  const isAdmin = authState.user.role.name === "LABORATORY_ADMIN";
  const [tableHeader, setTableHeader] = useState([]);
  const [tableBody, setTableBody] = useState([]);

  useEffect(() => {
    setTableHeader([
      "Unidad de negocio",
      "RUT",
      "Doctor",
      "Producto",
      "Presentación",
      "Concentración",
    ]);

    const tableData = orders.map((order) => {
      return {
        "Unidad de negocio": order?.laboratory?.name || "",
        RUT: order?.doctor?.rut || "",
        Doctor: `${order?.doctor?.name || ""} ${order?.doctor?.lastName || ""}`,
        Producto: order?.product?.name || "",
        Presentación: order?.product?.presentation || "",
        Concentración: order?.product?.concentration || "",
      };
    });
    setTableBody(tableData);
  }, [orders]);

  useEffect(() => {
    setReload(false);
    async function getOrders() {
      try {
        setLoading(true);
        const { status, response } = await orderServices.getOrders({
          laboratoryId: authState.user.laboratory._id,
          page,
          limit,
          token: authState.token,
          text: "",
        });
        setLoading(false);
        if (status === 200) {
          setOrders(response.orders);
          setLimit(response.limit);
          setCount(response.total);
          setPage(response.page);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
    getOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState, reload]);

  async function getOrdersFilter(text) {
    try {
      setLoading(true);
      const { status, response } = await orderServices.getOrders({
        laboratoryId: authState.user.laboratory._id,
        page,
        limit,
        token: authState.token,
        text,
      });
      setLoading(false);
      if (status === 200) {
        setOrders(response.orders);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  const updateOrder = async () => {
    try {
      setLoading(true);
      const { status: statusResp, response } = await orderServices.updateOrder({
        doctorId,
        productId,
        orderId,
        token: authState.token,
        quantity,
      });
      setLoading(false);
      if (statusResp === 200) {
        setReload(true);
        setToastMessage("Orden aprobada");
        setModal(false);
        setToast(true);
      } else if (statusResp === 401) {
        signOut();
      }
      if (response.error) {
        setToastMessage(response.error.message, true);
        setToast(true);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const confirmationModal = ({ doctorId, productId, orderId, reject }) => {
    setDoctorId(doctorId);
    setProductId(productId);
    setOrderId(orderId);
  };

  const rejectOrder = async () => {
    try {
      setLoading(true);
      const { status: statusResp, response } = await orderServices.rejectOrder({
        token: authState.token,
        orderId,
      });
      setLoading(false);
      if (statusResp === 200) {
        setReload(true);
        setToastMessage("Orden rechazada");
        setToast(true);
      } else if (statusResp === 401) {
        signOut();
      }
      if (response.error) {
        setToastMessage(response.error.message, true);
        setToast(true);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
    setOpenAlert(false);
  };

    const optionsToolbar = [
    {
      label: "Export excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Ordenes por aprobar",
          tableHeader: tableHeader,
          tableBody: tableBody,
        });
      },
    },
  ];

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container style={{ flex: 1 }}>
        <ConfirmationModal
          open={openAlert}
          setOpenAlert={setOpenAlert}
          setConfirmAction={rejectOrder}
        />
        <ModalBase open={modal} close={() => setModal(false)} title="Asignar">
          <form className={classes.form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  variant="outlined"
                  fullWidth
                  id="quantity"
                  label="Cantidad"
                  value={quantity}
                  name="quantity"
                  placeholder="Cantidad"
                  autoComplete="quantity"
                  onChange={(e) => setQuantity(filterNumber(e.target.value))}
                  size="small"
                  inputRef={register({
                    required: "La cantidad es requerida",
                  })}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.quantity ? true : false}
                  helperText={errors.quantity ? errors.quantity.message : ""}
                />
              </Grid>
            </Grid>
            <DialogActions>
              <Button
                onClick={updateOrder}
                fullWidth
                size="small"
                variant="contained"
                color="primary"
                className={classes.submit}
                style={{ textTransform: "capitalize", borderRadius: "20px" }}
              >
                Aceptar
              </Button>
            </DialogActions>
          </form>
        </ModalBase>
        {loading && <Loader loading={true} />}
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            <Toast
              message={toastMessage}
              open={toast}
              close={() => {
                setToast(false);
              }}
            />
            <Container maxWidth={false}>
              <SimpleToolbar
                reload={() => setReload(true)}
                onFilter={(text) => getOrdersFilter(text)}
                // table={"assignmentTable"}
                // filename={"Ordenes por aprobar"}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                // tableHeader={tableHeader}
                // tableBody={tableBody}
                options={optionsToolbar}
              />
              <BaseTable tableId="assignmentTable">
                <TableHead>
                  <StyledTableRow>
                    {isAdmin && (
                      <StyledTableCell>Unidad de negocio</StyledTableCell>
                    )}
                    <StyledTableCell>RUT</StyledTableCell>
                    <StyledTableCell>Doctor</StyledTableCell>
                    <StyledTableCell>Producto</StyledTableCell>
                    <StyledTableCell>Presentación</StyledTableCell>
                    <StyledTableCell>Concentración</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {orders.map((order, index) => (
                    <StyledTableRow hover key={order._id}>
                      {isAdmin && (
                        <StyledTableCell
                          style={{
                            color: index % 2 === 0 ? "#192A7F" : "#2196C0",
                          }}
                        >
                          {order.laboratory.name}
                        </StyledTableCell>
                      )}
                      <StyledTableCell>
                        {order.doctor.rut.charAt(
                          order.doctor.rut.length - 2
                        ) === "-"
                          ? order.doctor.rut
                          : `${order.doctor.rut.slice(
                              0,
                              order.doctor.rut.length - 1
                            )}-${order.doctor.rut.slice(
                              order.doctor.rut.length - 1
                            )}`}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >{`${order.doctor.name} ${order.doctor.lastName}`}</StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {order.product.name}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {order.product.presentation}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {order.product.concentration}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        <EnableDisableIconButton
                          status={false}
                          tooltipTitleEnable="Aprobar"
                          onClick={() => {
                            confirmationModal({
                              doctorId: order.doctor._id,
                              productId: order.product._id,
                              orderId: order._id,
                            });
                            setModal(true);
                            setOpenAlert(false);
                          }}
                        />
                        <EnableDisableIconButton
                          status={true}
                          tooltipTitleDisable="Rechazar"
                          onClick={() => {
                            confirmationModal({
                              doctorId: order.doctor._id,
                              productId: order.product._id,
                              orderId: order._id,
                            });
                            setOpenAlert(true);
                            setModal(false);
                          }}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(e.target.value);
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  form: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    width: "100%",
  },
  btnCancel: {
    backgroundColor: theme.palette.secondary.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  btnConfirm: {
    backgroundColor: theme.palette.primary.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#f44336",
  },

  dialogTitle: {
    textAlign: "Center",
  },
}));
